import { getInfo } from '@/api/public'
export default {
    state: {
        userInfo: {},
        roles: [],
        permissions: [],
        routers: []
    },
    mutations: {
        setUserInfo(state, data) {
            state.userInfo = data
        },
        setRoles(state, data) {
            state.roles = data
        },
        setPermissions(state, data) {
            state.userInfo = data
        },
        setRouters(state, data){
            state.routers = data
        }
    },
    actions: {
        getInfo() {
            // return new Promise((resolve, reject)=>{
            //     getInfo().then(res=>{
            //         this.commit('setUserInfo', res.user)
            //         this.commit('setRoles', res.roles)
            //         this.commit('setPermissions', res.permissions)
            //         resolve(res)
            //     }).catch(err=>{
            //         reject(err)
            //     })
            // })
        },
    }
}